import { FileType } from '@/helpers/benefitsConfig'
import { userService } from '@/services/userService'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import styles from './VipLimit.module.less'

type LimitType = 'batch_upload' | 'parse_speed'

type VipLimitProps = {
  fileType: FileType
  limitTypeList: Array<LimitType>
}

export const VipLimit = observer((props: VipLimitProps) => {
  const { fileType, limitTypeList } = props

  const vipLimitInfo = limitTypeList.map((limitType) => {
    if (limitType === 'parse_speed') {
      return `文件解析速度为：${userService.getPlanFileMaxRule(fileType).fileParseSpeed} 页/分钟`
    }
    if (limitType === 'batch_upload') {
      return `可批量翻译：${userService.getPlanFileMaxRule(fileType).batchUploadCount} 个文件`
    }
  })

  return (
    <div className={classNames(styles.vipLimit)}>
      当前为：{userService.vipVersionName}
      <div className={classNames(styles.vipLimitInfo)}>
        {vipLimitInfo.map((limitText, idx) => {
          return (
            <span key={idx}>
              {vipLimitInfo.length === 1 && '。'}
              {idx !== 0 && '，'}
              {limitText}
            </span>
          )
        })}
      </div>
    </div>
  )
})

export const FileExpirationTimeLimit = observer((props: { fileSaveTime: string }) => {
  const { fileSaveTime } = props
  return (
    <div className={classNames(styles.fileExpirationTimeLimit)}>
      文件将被安全保留：{fileSaveTime}
    </div>
  )
})
